import React, { useEffect } from "react";
import { Alert, Card, Spinner, Table } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { useApp } from 'common/AppContext';
import moment from "moment";
import { FormattedMessage, useIntl, FormattedNumber } from "react-intl";

const ProductUsageTable = props => {

    const [state, setState] = useSuperState({
        loading: false,
        error: null,
        table_data: null
    });

    const { appstream_fleet_name } = props;
    const { api } = useApp();
    const { formatDate } = useIntl();

    let start_date = props?.start_date ? moment(props?.start_date).toISOString() : moment().subtract(30, 'days').toISOString();
    let end_date = props?.end_date ? moment(props?.end_date).toISOString() : moment().toISOString();

    const refreshTable = async () => {

        try {

            setState({ loading: true });

            let { results } = await api.get(`/api/appstream/product/stats/all`, { start_date, end_date });

            setState({
                table_data: results,
                loading: false
            });

        } catch ({ err }) {

            setState({
                loading: false,
                error: err
            });

        }

    };

    useEffect(() => {
        refreshTable();
    }, [appstream_fleet_name, start_date, end_date]);

    const { loading, error, table_data } = state;

    return (
        <>
            <Card {...props}>
                <Card.Header>Product Usage Totals</Card.Header>
                <Card.Body>
                    <Alert variant="danger" show={error} onClose={() => setState({ error: null })} dismissible>
                        {error}
                    </Alert>
                    {loading &&
                        <div className="text-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    }
                    {!loading && <>
                        {table_data ?
                                (
                                    <div>
                                        <Table responsive striped hover>
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th className="text-center">Total Sessions</th>
                                                    <th className="text-center">
                                                        Total Time
                                                        <br/>
                                                        <small className="text-secondary">(minutes)</small>
                                                    </th>
                                                    <th className="text-end">
                                                        Avg Session Duration
                                                        <br/>
                                                        <small className="text-secondary">(minutes)</small>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {table_data.map((rec, idx) => {

                                                    let { appstream_fleet_name, fleet_name, product_name, sessions_total, minutes_total } = rec;

                                                    return (
                                                        <tr key={idx}>
                                                            <td className="align-middle">
                                                                <b>
                                                                    {product_name}
                                                                </b>
                                                                <br/>
                                                                <small className="text-secondary">{fleet_name}</small>
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                <FormattedNumber value={sessions_total}/>
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                <FormattedNumber value={minutes_total}/>
                                                            </td>
                                                            <td className="text-end align-middle">
                                                                {sessions_total > 0 ? <FormattedNumber value={Math.floor(minutes_total / sessions_total)}/> : '-'}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr>
                                                    <td colspan={4} className="bg-dark-subtle"/>
                                                </tr>
                                                {(() => {

                                                    let total_sessions = Object.keys(table_data).reduce((acc, key) => acc + table_data[key]['sessions_total'], 0);
                                                    let total_minutes = Object.keys(table_data).reduce((acc, key) => acc + table_data[key]['minutes_total'], 0);

                                                    return (<tr className="bg-white">
                                                        <td className="align-middle">
                                                            <b>Total</b>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <FormattedNumber value={total_sessions}/>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <FormattedNumber value={total_minutes}/>
                                                        </td>
                                                        <td className="text-end align-middle">
                                                            {total_sessions > 0 ? <FormattedNumber value={Math.floor(total_minutes / total_sessions)}/> : '-'}
                                                        </td>
                                                    </tr>);
                                                })()}

                                            </tbody>
                                        </Table>
                                    </div>
                                )
                                :
                                (
                                    <div className="d-flex align-items-center justify-content-center text-muted h-100">
                                        <FormattedMessage
                                            id="label.no_usage_data_found"
                                            defaultMessage="No usage data found"
                                        />
                                    </div>
                                )
                        }
                        </>
                    }
                </Card.Body>
            </Card>
        </>
    );

};

export default ProductUsageTable;
